"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _marketingCommodity = require("@/api/marketingFunction/supersubsidy/marketingCommodity");
var _marketingOrder = require("@/api/marketingFunction/supersubsidy/marketingOrder");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'MarketingEvents',
  data: function data() {
    return {
      options: [],
      queryData: {
        orderNo: '',
        title: '',
        goodsId: '',
        memberId: '',
        platformCode: '',
        activityId: '',
        orderStatus: '',
        page: {
          page: 1,
          size: 10
        }
      },
      tableData: [],
      total: 0,
      // 条数
      platformMapping: {
        'TB': '淘宝',
        'JD': '京东',
        'PDD': '拼多多',
        'WPH': '唯品会',
        'DY': '抖音'
      }
    };
  },
  created: function created() {
    this.productAll();
    this.orderList();
  },
  methods: {
    onDetails: function onDetails(data) {
      console.log('data', data);
      this.$router.push({
        path: '/orderManagement/orderDetails',
        query: {
          orderNo: data.orderNo,
          unionCode: data.platformCode
        }
      });
    },
    productAll: function () {
      var _productAll2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
        var params, res, _t;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              params = {};
              _context.n = 1;
              return (0, _marketingCommodity.productAll)(params);
            case 1:
              res = _context.v;
              this.options = res.data;
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              console.log(_t);
            case 3:
              return _context.a(2);
          }
        }, _callee, this, [[0, 2]]);
      }));
      function productAll() {
        return _productAll2.apply(this, arguments);
      }
      return productAll;
    }(),
    onInquire: function onInquire() {
      this.queryData.page.page = 1;
      this.queryData.page.size = 10;
      this.orderList();
    },
    onInitialize: function onInitialize() {
      this.queryData = {
        orderNo: '',
        title: '',
        goodsId: '',
        memberId: '',
        platformCode: '',
        activityId: '',
        orderStatus: '',
        page: {
          page: 1,
          size: 10
        }
      };
      this.orderList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.queryData.page.size = val;
      this.orderList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.queryData.page.page = val;
      this.orderList();
    },
    orderList: function () {
      var _orderList2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2() {
        var params, res, _t2;
        return (0, _regenerator2.default)().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              params = (0, _objectSpread2.default)({}, this.queryData);
              _context2.n = 1;
              return (0, _marketingOrder.orderList)(params);
            case 1:
              res = _context2.v;
              this.tableData = res.data.data;
              this.total = res.data.total;
              _context2.n = 3;
              break;
            case 2:
              _context2.p = 2;
              _t2 = _context2.v;
              console.log(_t2);
            case 3:
              return _context2.a(2);
          }
        }, _callee2, this, [[0, 2]]);
      }));
      function orderList() {
        return _orderList2.apply(this, arguments);
      }
      return orderList;
    }(),
    // 用户详情
    onUserDetails: function onUserDetails(value) {
      this.$router.push({
        path: '/member/userDetails',
        query: {
          memberId: value.memberId,
          nickname: value.username
        }
      });
    }
  }
};